export default "__VITE_ASSET__DxAmlMOA__"